document.addEventListener(
    'DOMContentLoaded',
    function () {
        const dni = document.querySelector('#dni');
        const nombre =
            document.querySelector('#nombre');

        const mensaje = document.querySelector(
            '#mensaje-dni-usuario'
        );

        if (!dni || !nombre || !mensaje) {
            return;
        }

        dni.addEventListener('input', function () {
            this.value = this.value
                .replace(/\D/g, '')
                .slice(0, 13);

            if (!this.readOnly) {
                nombre.value = '';
                mensaje.textContent = '';
                mensaje.className = 'mensaje-form';
            }
        });

        dni.addEventListener('blur', async function () {
            if (dni.readOnly) {
                return;
            }

            const identidad = dni.value.trim();

            if (!/^\d{13}$/.test(identidad)) {
                nombre.value = '';

                mensaje.textContent =
                    'La identidad debe tener 13 dígitos.';

                mensaje.className =
                    'mensaje-form error';

                return;
            }

            mensaje.textContent =
                'Buscando persona...';

            mensaje.className =
                'mensaje-form warning';

            try {
                const respuesta = await fetch(
                    '/index.php/persona/buscar?identidad='
                    + encodeURIComponent(identidad)
                );

                const datos = await respuesta.json();

                if (!respuesta.ok) {
                    throw new Error(
                        'No se pudo realizar la consulta.'
                    );
                }

                if (!datos.encontrado) {
                    nombre.value = '';

                    mensaje.textContent =
                        'La identidad no está registrada en personas.';

                    mensaje.className =
                        'mensaje-form error';

                    return;
                }

                nombre.value = datos.nombre;

                mensaje.textContent =
                    'Persona encontrada correctamente.';

                mensaje.className =
                    'mensaje-form success';

            } catch (error) {
                nombre.value = '';

                mensaje.textContent =
                    'No se pudo consultar la identidad.';

                mensaje.className =
                    'mensaje-form error';
            }
        });
    }
);